import Vue from 'vue';
import VueRouter from 'vue-router';
import { getLopToken } from '@/utils/auth';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('@/views/player.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  const token = getLopToken();

  if (whiteList.indexOf(to.path) !== -1) return next();

  if (token) {
    next();
  } else {
    next('/login');
  }
});

export default router;
